import is from 'typescript-styled-is'
import styled from '../../../theme'

export const SlideWrapper = styled.div<ISlideWrapperProps>`
  position: absolute;
  overflow: hidden;
  z-index: 151 !important;
  pointer-events: none;
  display: none;
  ${is('show')`
    display: block;
  `};

  //transition: left 0.8s cubic-bezier(1, -0.55, 0.2, 1.37);

  ${is('isCenterOnMobile')`
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 151 !important;
    box-shadow: 0px 0px 12px -5px #333;
  `};

  ${is('transcendens')`
    top: 50vh !important;
    left: 50vw !important;
    transform: translate(-50%, -50%) !important;
    z-index: 151 !important;
    box-shadow: 0px 0px 12px -5px #333;
  `}

  top: ${props => props.y}px;
  left: ${props => props.x}px;
`

export interface ISlideWrapperProps {
  sized?: boolean
  x: number
  y: number
  show?: boolean
  isCenterOnMobile?: boolean
  transcendens?: boolean
}
